import React, { useEffect } from "react";
import { useState } from "react";
import { saveMid, getMerchantDetails } from "../../api/index";
import "./transaction-details.scss";
import TransactionTable from "./TransactionTable";
import Select from "react-select";
import BatchChart from "./BatchChart";
import TransactionPieChart from "./TransactionPieChart";
import TransactionLineChart from "./TransactionLineChart";
import { Table, Accordion, Card } from "react-bootstrap";
import ShowMerchantStatement from "./ShowMerchantStatement";
import { AiOutlineFullscreen } from "react-icons/ai";
import { AiOutlineFullscreenExit } from "react-icons/ai";
import { OverlayTrigger, Tooltip, Button } from "react-bootstrap";

const transactionDetails = (props) => {
    const [selectedYear, setSelectedYear] = useState(null);
    const [selectedMonth, setSelectedMonth] = useState(null);
    const [mid_field, setMidField] = useState("");
    const [field_error, setFieldError] = useState("");
    const [submitted, setSubmitted] = useState(false);
    const [merchantInfo, setMerchantInfo] = useState(null);

    const [downloadYear, setDownloadYear] = useState(null);
    const [downloadMonth, setDownloadMonth] = useState(null);

    const [openPdfModal, setPdfModal] = useState(false);
    const [merchStateError, setMerchError] = useState("");
    const [isFulScreen, setFullScreen] = useState(false);

    useEffect(() => {
        getMerchantDetails({ powerapp_id: props.appDataId }).then((res) => {
            if (res.status) {
                setMerchantInfo(res.data);
            }
        });
    }, []);

    let yearList = [{ label: "Select", value: "" }];
    for (let i = 2024; i >= 2019; i--) {
        yearList.push({ label: i, value: i });
    }

    var monthNameList = [
        { label: "Select", value: "" },
        { label: "January", value: "January" },
        { label: "February", value: "February" },
        { label: "March", value: "March" },
        { label: "April", value: "April" },
        { label: "May", value: "May" },
        { label: "June", value: "June" },
        { label: "July", value: "July" },
        { label: "August", value: "August" },
        { label: "September", value: "September" },
        { label: "October", value: "October" },
        { label: "November", value: "November" },
        { label: "December", value: "December" },
    ];

    const submitMid = () => {
        if (mid_field.length == 0) {
            setFieldError("Please fill MID field");
            return 0;
        }
        saveMid({
            powerapp_id: props.appDataId,
            mid: mid_field,
        })
            .then((res) => {
                if (res.status) {
                    setSubmitted(true);
                } else {
                    setFieldError(res.message);
                }
            })
            .catch((err) => {});
    };

    const downloadStatementClick = () => {
        if (downloadYear !== null && downloadMonth !== null) {
            setPdfModal(true);
        } else {
            setMerchError("Please select Month & Year");
        }
    };

    const makeFullScreen = () => {
        setFullScreen(!isFulScreen);
    };

    return (
        <div
            className={`transaction-details-page ${isFulScreen ? "fullscreen" : ""}`}
        >
            <div className="TransactionData fullscreen-btn-sec">
                <button
                    type="button"
                    className="btn-fullscreen"
                    onClick={makeFullScreen}
                    title="Toggle Full Screen!"
                >
                    {isFulScreen ? (
                        <AiOutlineFullscreenExit fontSize={26} />
                    ) : (
                        <AiOutlineFullscreen fontSize={26} />
                    )}
                </button>
            </div>

            <div className="TransactionData">
                <Accordion>
                    <Card>
                        <Accordion.Toggle as={Card.Header} eventKey="0">
                            Merchant Info
                        </Accordion.Toggle>
                        <Accordion.Collapse eventKey="0">
                            <Card.Body>
                                {merchantInfo == null ? (
                                    <>
                                        <div class="dots"></div>
                                    </>
                                ) : (
                                    <div>
                                        <Table responsive="sm">
                                            <thead>
                                                <tr>
                                                    <th>Merchant Info</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>MID</td>
                                                    <td>{merchantInfo?.MID}</td>
                                                    <td>CustomerNumber</td>
                                                    <td>
                                                        {
                                                            merchantInfo?.CustomerNumber
                                                        }
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>DBA</td>
                                                    <td>{merchantInfo?.DBA}</td>
                                                    <td>LegalName</td>
                                                    <td>
                                                        {
                                                            merchantInfo?.LegalName
                                                        }
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td>PhoneNumber</td>
                                                    <td>
                                                        {
                                                            merchantInfo?.PhoneNumber
                                                        }
                                                    </td>
                                                    <td>EMail</td>
                                                    <td>
                                                        {merchantInfo?.EMail}
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td>Website</td>
                                                    <td>
                                                        {merchantInfo?.Website}
                                                    </td>
                                                    <td>Office</td>
                                                    <td>
                                                        {merchantInfo?.Office}
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td>Branch</td>
                                                    <td>
                                                        {merchantInfo?.Branch}
                                                    </td>
                                                    <td>RepCode</td>
                                                    <td>
                                                        {merchantInfo?.RepCode}
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td>MCC ID</td>
                                                    <td>{merchantInfo?.MCC}</td>
                                                    <td>StatusDescription</td>
                                                    <td>
                                                        {
                                                            merchantInfo?.StatusDescription
                                                        }
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td>Opened</td>
                                                    <td>
                                                        {merchantInfo?.Opened}
                                                    </td>
                                                    <td>Closed</td>
                                                    <td>
                                                        {merchantInfo?.Closed}
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td>FirstStatement</td>
                                                    <td>
                                                        {
                                                            merchantInfo?.FirstStatement
                                                        }
                                                    </td>
                                                    <td>LastStatement</td>
                                                    <td>
                                                        {
                                                            merchantInfo?.LastStatement
                                                        }
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>AmExID</td>
                                                    <td>
                                                        {merchantInfo?.AmExID}
                                                    </td>
                                                    <td>DiscoverID</td>
                                                    <td>
                                                        {
                                                            merchantInfo?.DiscoverID
                                                        }
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td>PCIStatus</td>
                                                    <td>
                                                        {
                                                            merchantInfo?.PCIStatus
                                                        }
                                                    </td>
                                                    <td>FederalTaxID</td>
                                                    <td>
                                                        {
                                                            merchantInfo?.FederalTaxID
                                                        }
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td>TINStatus</td>
                                                    <td>
                                                        {
                                                            merchantInfo?.TINStatus
                                                        }
                                                    </td>
                                                    <td>MonthlyCap</td>
                                                    <td>
                                                        {
                                                            merchantInfo?.MonthlyCap
                                                        }
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Reserve</td>
                                                    <td>
                                                        {merchantInfo?.Reserve}
                                                    </td>
                                                    <td>OnHold</td>
                                                    <td>
                                                        {merchantInfo?.OnHold}
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td>eCommerceStatus</td>
                                                    <td>
                                                        {
                                                            merchantInfo?.eCommerceStatus
                                                        }
                                                    </td>
                                                    <td>LeaseStatus</td>
                                                    <td>
                                                        {
                                                            merchantInfo?.LeaseStatus
                                                        }
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td>ProcessingStatus</td>
                                                    <td>
                                                        {
                                                            merchantInfo?.ProcessingStatus
                                                        }
                                                    </td>
                                                    <td>
                                                        CheckProcessingStatus
                                                    </td>
                                                    <td>
                                                        {
                                                            merchantInfo?.CheckProcessingStatus
                                                        }
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        WebHostingOnlyStatus
                                                    </td>
                                                    <td>
                                                        {
                                                            merchantInfo?.WebHostingOnlyStatus
                                                        }
                                                    </td>
                                                    <td>GiftCardStatus</td>
                                                    <td>
                                                        {
                                                            merchantInfo?.GiftCardStatus
                                                        }
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>CashAdvanceStatus</td>
                                                    <td>
                                                        {
                                                            merchantInfo?.CashAdvanceStatus
                                                        }
                                                    </td>
                                                    <td>
                                                        ExtendWarrantyStatus
                                                    </td>
                                                    <td>
                                                        {
                                                            merchantInfo?.ExtendWarrantyStatus
                                                        }
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>ReserveBalance</td>
                                                    <td>
                                                        {
                                                            merchantInfo?.ReserveBalance
                                                        }
                                                    </td>
                                                        <td>MonthToDateSales</td>
                                                        <td>      {
                                                            merchantInfo?.MonthToDateSales
                                                        }</td>
                                                </tr>
                                            </tbody>
                                        </Table>
                                        <Table responsive="sm">
                                            <thead>
                                                <tr>
                                                    <th>DBAAddress</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>Address</td>
                                                    <td>
                                                        {
                                                            merchantInfo
                                                                ?.DBAAddress
                                                                ?.Address
                                                        }
                                                    </td>
                                                    <td>City</td>
                                                    <td>
                                                        {
                                                            merchantInfo
                                                                ?.DBAAddress
                                                                ?.City
                                                        }
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>State</td>
                                                    <td>
                                                        {
                                                            merchantInfo
                                                                ?.DBAAddress
                                                                ?.State
                                                        }
                                                    </td>
                                                    <td>ZipCode</td>
                                                    <td>
                                                        {
                                                            merchantInfo
                                                                ?.DBAAddress
                                                                ?.ZipCode
                                                        }
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </Table>
                                        <Table responsive="sm">
                                            <thead>
                                                <tr>
                                                    <th>LegalAddress</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>Address</td>
                                                    <td>
                                                        {
                                                            merchantInfo
                                                                ?.LegalAddress
                                                                ?.Address
                                                        }
                                                    </td>
                                                    <td>City</td>
                                                    <td>
                                                        {
                                                            merchantInfo
                                                                ?.LegalAddress
                                                                ?.City
                                                        }
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>State</td>
                                                    <td>
                                                        {
                                                            merchantInfo
                                                                ?.LegalAddress
                                                                ?.State
                                                        }
                                                    </td>
                                                    <td>ZipCode</td>
                                                    <td>
                                                        {
                                                            merchantInfo
                                                                ?.LegalAddress
                                                                ?.ZipCode
                                                        }
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </Table>
                                        {merchantInfo?.Owners?.map(
                                            (owner, index) => {
                                                return (
                                                    <Table responsive="sm">
                                                        <thead>
                                                            <tr>
                                                                <th>
                                                                    Owner(
                                                                    {index + 1})
                                                                </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr>
                                                                <td>
                                                                    FirstName
                                                                </td>
                                                                <td>
                                                                    {
                                                                        owner.FirstName
                                                                    }
                                                                </td>
                                                                <td>
                                                                    LastName
                                                                </td>
                                                                <td>
                                                                    {
                                                                        owner.LastName
                                                                    }
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>Address</td>
                                                                <td>
                                                                    {
                                                                        owner.Address
                                                                    }
                                                                </td>
                                                                <td>
                                                                    Address2
                                                                </td>
                                                                <td>
                                                                    {
                                                                        owner.Address2
                                                                    }
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>City</td>
                                                                <td>
                                                                    {owner.City}
                                                                </td>
                                                                <td>State</td>
                                                                <td>
                                                                    {
                                                                        owner.State
                                                                    }
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>ZipCode</td>
                                                                <td>
                                                                    {
                                                                        owner.ZipCode
                                                                    }
                                                                </td>
                                                                <td>
                                                                    DateOfBirth
                                                                </td>
                                                                <td>
                                                                    {
                                                                        owner.DateOfBirth
                                                                    }
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>E-Mail</td>
                                                                <td>
                                                                    {
                                                                        owner[
                                                                            "E-Mail"
                                                                        ]
                                                                    }
                                                                </td>
                                                                <td>
                                                                    BusinessEmail
                                                                </td>
                                                                <td>
                                                                    {
                                                                        owner.BusinessEmail
                                                                    }
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    PhoneNumber
                                                                </td>
                                                                <td>
                                                                    {
                                                                        owner.PhoneNumber
                                                                    }
                                                                </td>
                                                                <td>
                                                                    MobilePhoneNumber
                                                                </td>
                                                                <td>
                                                                    {
                                                                        owner.MobilePhoneNumber
                                                                    }
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    OwnershipPercent
                                                                </td>
                                                                <td>
                                                                    {
                                                                        owner.OwnershipPercent
                                                                    }
                                                                </td>
                                                                <td>
                                                                    IsSigner
                                                                </td>
                                                                <td>
                                                                    {owner.IsSigner
                                                                        ? "Yes"
                                                                        : "No"}
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    IsManagement
                                                                </td>
                                                                <td>
                                                                    {owner.IsManagement
                                                                        ? "Yes"
                                                                        : "No"}
                                                                </td>
                                                                <td></td>
                                                                <td></td>
                                                            </tr>
                                                        </tbody>
                                                    </Table>
                                                );
                                            },
                                        )}
                                    </div>
                                )}
                            </Card.Body>
                        </Accordion.Collapse>
                    </Card>
                </Accordion>
            </div>

            <div className="TransactionData">
                <div className="row">
                    <div className="col-md-6">
                        <Select
                            isClearable={true}
                            isSearchable={true}
                            name="year"
                            options={yearList}
                            onChange={(selected) => {
                                setMerchError("");
                                setSelectedYear(selected.value);
                            }}
                        />
                    </div>
                    <div className="col-md-6">
                        <Select
                            isClearable={true}
                            isSearchable={true}
                            name="month"
                            options={monthNameList}
                            onChange={(selected) => {
                                setMerchError("");
                                setSelectedMonth(selected.value);
                            }}
                        />
                    </div>
                </div>
            </div>

            <div className="TransactionChart">
                <h4>Batch Data</h4>
                <div className="row">
                    <div className="col-md-12">
                        <BatchChart
                            selectedYear={selectedYear}
                            powerappId={props.appDataId}
                        />
                    </div>
                </div>
            </div>

            <div className="TransactionChart">
                <h4>Transaction Data</h4>
                <div className="row">
                    <div className="col-md-8">
                        <TransactionLineChart
                            selectedYear={selectedYear}
                            selectedMonth={selectedMonth}
                            powerappId={props.appDataId}
                        />
                    </div>
                    <div className="col-md-4" style={{ paddingTop: "4rem" }}>
                        <TransactionPieChart
                            powerappId={props.appDataId}
                            selectedYear={selectedYear}
                        />
                    </div>
                </div>
            </div>
            <div className="TransactionData">
                <TransactionTable
                    powerappId={props.appDataId}
                    selectedYear={selectedYear}
                    selectedMonth={selectedMonth}
                />
            </div>

            {/* Download Merchant statement option  */}
            <div className="TransactionData merch-statement">
                <h4>Download Merchant Statements</h4>
                <div className="row">
                    <div className="col-md-5">
                        <Select
                            isClearable={true}
                            isSearchable={true}
                            name="year"
                            options={yearList}
                            onChange={(selected) =>
                                setDownloadYear(selected.value)
                            }
                        />
                    </div>
                    <div className="col-md-5">
                        <Select
                            isClearable={true}
                            isSearchable={true}
                            name="month"
                            options={monthNameList}
                            onChange={(selected) =>
                                setDownloadMonth(selected.value)
                            }
                        />
                    </div>
                    <div className="col-md-2">
                        <button
                            className="btn btn-secondary-outline"
                            onClick={downloadStatementClick}
                        >
                            Download
                        </button>
                    </div>
                </div>
                <p className="error-message">{merchStateError}</p>
            </div>

            {/* Modal Box id MID is not present */}
            {props.app_data?.power_app_submission == null ||
            props.app_data?.power_app_submission?.mid == null ||
            props.app_data?.power_app_submission?.mid == "" ? (
                <div className="no-mid-box">
                    <div className="message-box">
                        {submitted ? (
                            <>
                                <p>
                                    MID is updated successfully, Please wait
                                    while we are fetching merchant's data
                                </p>
                                <p>Please come back after few minutes</p>
                                <div class="dots"></div>
                            </>
                        ) : (
                            <>
                                <p>
                                    This application does not have a MID
                                    associated with it. Please associate an MID
                                    to proceed.
                                </p>

                                <div class="input-group-cus">
                                    <input
                                        type="text"
                                        class="form-control"
                                        placeholder="Application's MID"
                                        onKeyUp={(e) => {
                                            setMidField(e.target.value);
                                        }}
                                    />
                                    <button
                                        class="btn btn-outline-secondary"
                                        type="button"
                                        onClick={submitMid}
                                    >
                                        <i
                                            class="fa fa-plus-square"
                                            aria-hidden="true"
                                        ></i>
                                    </button>
                                </div>
                                <p className="error-message">{field_error}</p>
                            </>
                        )}
                    </div>
                </div>
            ) : (
                <></>
            )}

            {/* Merchant Statement  */}
            {openPdfModal && (
                <ShowMerchantStatement
                    open={openPdfModal}
                    close={() => setPdfModal(false)}
                    powerappId={props.appDataId}
                    year={downloadYear}
                    month={downloadMonth}
                />
            )}
        </div>
    );
};

export default transactionDetails;
